import './global.less'

import { AE } from '@agora/ae-client'
import { createErrorBoundary } from '@web/react-common'
import { UseRequestProvider } from 'ahooks'
import { message } from 'antd'
import axios from 'axios'
import { Provider } from 'jotai'
import { isArray, isString, values } from 'lodash'
import qs from 'query-string'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'

import { alert } from '@/utils/alert'

import { AppContainer } from './modules/app'
import Login from './modules/user/login.component'

// 必须在最后面，用于覆盖 antd 样式
// prettier-ignore
import 'virtual:windi.css'

AE.init({
  appId: 'pmo',
})

axios.defaults.paramsSerializer = qs.stringify

const parseError = (msg: any) => {
  let result = ''
  if (isString(msg)) {
    result = msg
  } else if (isArray(msg)) {
    msg
      .flatMap((m) => {
        if (m.constraints) {
          return values(m.constraints)
        }
        return []
      })
      .forEach((m) => {
        result += m + '\n'
      })
  } else {
    result = JSON.stringify(msg)
  }
  return result
}

axios.interceptors.response.use(undefined, (err) => {
  if (axios.isCancel(err)) {
    return
  }
  if (err && err.response.status === 401) {
    window.location.href = `/api/oauth/login?state=${encodeURIComponent(window.location.href)}`
    return
  }
  const status = err.response.status
  const msg = err.response?.data || err.message

  const error = parseError(msg)
  if (status === 400 || status === 403) {
    message.warn(`错误信息: ${error}`)
  }
  if (status >= 500) {
    alert({ message: `服务器错误: ${JSON.stringify(msg)}` })
    message.error(`服务器错误: ${msg}`)
  }
  return Promise.reject(err)
})

const ErrorBoundary = createErrorBoundary(alert)

const App = () => (
  <ErrorBoundary>
    <Provider>
      <BrowserRouter>
        <UseRequestProvider
          value={{
            refreshOnWindowFocus: false,
            focusTimespan: 60_000,
            pollingWhenHidden: false,
            requestMethod: (params) => axios(params).then((res) => res.data),
          }}
        >
          <Login>
            <AppContainer />
          </Login>
        </UseRequestProvider>
      </BrowserRouter>
    </Provider>
  </ErrorBoundary>
)

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)
